export default __webpack_public_path__ + "static/media/mongodb.3f2dab44.jpg";